import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { provideWithTranslations, NgxI18nTranslationLoaderGuard } from '@studiohyperdrive/ngx-i18n';

import { ProductDataModule } from '@cjm/shared/products';
import { CJMRoutes, VLoketAppRoutePaths } from '@cjm/shared/route-paths';
import { StoreSlice } from '@cjm/shared/store';
import {
	AdvicePagesApiService,
	advicePagesReducers,
	MyAssociationAPIService,
	myAssociationReducers
} from '@cjm/v-loket/repositories';

import { InTheSpotlightApiService, reducers } from '../data';
import { HomeTranslationLoader } from '../i18n';

import { HomePageComponent } from './pages';

export const HomeRoutes: CJMRoutes = [
	provideWithTranslations(
		{
			path: VLoketAppRoutePaths.Empty,
			component: HomePageComponent,
			canActivate: [NgxI18nTranslationLoaderGuard],
			providers: [
				// Services
				MyAssociationAPIService,
				AdvicePagesApiService,
				InTheSpotlightApiService,
				// Store
				importProvidersFrom(ProductDataModule),
				importProvidersFrom(StoreModule.forFeature(StoreSlice.MyAssociation, myAssociationReducers)),
				importProvidersFrom(StoreModule.forFeature(StoreSlice.Advices, advicePagesReducers)),
				importProvidersFrom(StoreModule.forFeature(StoreSlice.Home, reducers))
			]
		},
		HomeTranslationLoader
	)
];
